export default __webpack_public_path__ + "assets/vertical-dots.a84afbfb.png";